import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from '../contexts/SnackbarProvider';
import GlobalError from '../components/GlobalError';
import axiosInstance from '../utils/axiosInstance';
import { useSelectRow } from '../utils/useSelectRow';
import useDataFetch from '../hooks/useDataFetch';
import { getFields, searchFields } from '../utils/fields';
import { formatDate, formatDateTime } from '../utils/format';
import SearchForm from '../components/SearchForm';
import TableView from '../components/TableView';
import Pagination from '../components/Pagination';
import RelatedMenu from '../components/RelatedMenu';
import { Stack, Button, Checkbox, Icon, Link, Typography, Paper, Tabs, Tab } from "@mui/material";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
const OrdersCompletePage = () => {
  const { showSnackbar } = useSnackbar();
  const [tab, setTab] = useState(6);
  const navigate = useNavigate();
  const {
    dataset,
    error,
    currentPage,
    totalPages,
    searchQuery,
    setSearchQuery,
    handleSearchChange,
    handleSearchSubmit,
    handleClearSearch,
    handlePageChange,
    refetch
  } = useDataFetch('/order', { is_completed: false, order_numbers: '', client_name: '', dates: '', order_status: [6] });
  useEffect(() => {
    setSearchQuery(prev => ({
      ...prev,
      order_status: [tab],
    }));
  }, [tab]);

  useEffect(() => {
    refetch(1, searchQuery);
  }, [searchQuery]);
  // useSelectRow フックを使って選択状態を管理
  const { selectedItems, setSelectedItems, handleRowSelect, handleSelectAll } = useSelectRow('order_id');

  // 完了処理ボタンのクリック
  const handleCompleteStatus = async (status) => {
    if (selectedItems.length === 0) {
      alert('注文を選択してください');
      return;
    }

    try {
      await axiosInstance.post('/order/update-status', {
        orderIds: selectedItems,
        status: status, // 完了ステータス
      });
      showSnackbar('選択した注文のステータスを変更しました。', 'success');
      setSelectedItems([]); // 選択状態をリセット
      handlePageChange(1); // 1ページ目に戻してデータ再取得
      refetch();
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        console.error(err);
      }
      showSnackbar(err?.response?.data?.message || 'ステータス変更に失敗しました', 'error');
    }
  };

  // 検索フィールド定義
  const fieldsToInclude = ['dates', 'order_numbers', 'client_name'];
  let searchItems = getFields(searchFields, fieldsToInclude);

  // カラム定義
  const columns = [
    {
      label: (
        <Checkbox
          checked={selectedItems.length === dataset.length}
          indeterminate={selectedItems.length > 0 && selectedItems.length < dataset.length}
          onChange={(e) => handleSelectAll(e, dataset)}
        />
      ),
      accessor: 'checkbox',
      render: (item) => (
        <Checkbox
          checked={selectedItems.includes(item.order_id)}
          onChange={() => handleRowSelect(item.order_id)}
        />
      ),
      width: '50px',
    },
    {
      label: '注文日',
      accessor: 'order_date',
      format: (date) => formatDateTime(date),
      width: '160px',
    },
    {
      label: '注文番号',
      accessor: 'order_number',
      render: (item) => (
        <Link
          component="button"
          onClick={() => navigate(`/orders/${item.order_id}`)}>
          {item.order_number}
        </Link>
      ),
      width: '180px',
    },
    {
      label: 'ステータス',
      accessor: 'order_status_name',
      width: '170px',
    },
    {
      label: '希望納期',
      accessor: 'delivery_date',
      format: (date) => formatDate(date),
      width: '160px',
    },
    {
      label: '会社名＋事業所名',
      accessor: 'client_name',
      render: (item) => <Typography>{item.client_name} {item.branch_name}</Typography>,
      width: '250px',
    },
  ];

  const links = [
    { path: '/orders/new', label: '新規注文作成', icon: 'library_add' },
    { path: '/orders', label: '在庫一覧', icon: 'inventory_2' },
  ];

  if (error) return <GlobalError errorMessage={error} />;
  return (
    <>
      <Typography variant="h1" component="h1">注文完了処理</Typography>
      <div className='grid2-2_1'>
        {/* 検索フォーム */}
        <SearchForm
          searchQuery={searchQuery}
          searchFields={searchItems}
          handleSearchChange={handleSearchChange}
          handleSearchSubmit={handleSearchSubmit}
          handleClearSearch={handleClearSearch}
        />
        <RelatedMenu links={links} />
      </div>
      <Paper variant='section'>
        <Tabs
          value={tab}
          onChange={(e, v) => {
            setTab(v);
            setSelectedItems([]);
          }}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label="配送待ち" value={6} />
          <Tab label="出荷済み" value={7} />
        </Tabs>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 3, mb: 1 }}>
          <LocalShippingIcon color="primary" />
          <Typography component='h2' variant='h4'>{tab === 6 ? "配送待ち一覧" : "出荷済み一覧"}</Typography>
        </Stack>
        {/* テーブル */}
        <TableView dataset={dataset} columns={columns} />

        {/* ページネーション */}
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
        {/* ボタンエリア */}
        <div className='button-row'>
          {tab === 6 && (
            <Button
              variant="contained"
              onClick={() => handleCompleteStatus(7)}
              startIcon={<Icon>send_to_mobile</Icon>}
            >
              出荷済みにする
            </Button>
          )}

          {tab === 7 && (
            <Button
              variant="contained"
              onClick={() => handleCompleteStatus(10)}
              startIcon={<Icon>send_to_mobile</Icon>}
            >
              納品完了にする
            </Button>
          )}
        </div>
      </Paper>

    </>
  );
};

export default OrdersCompletePage;
